/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ApiDeliverySearchNFilterGridViewPostRequest } from "../models";
// @ts-ignore
import { ApiInvoiceDRAFTPatchRequest } from "../models";
// @ts-ignore
import { DocumentFilterDimensions } from "../models";
// @ts-ignore
import { FileUriODataResultCollection } from "../models";
// @ts-ignore
import { InvoiceModel } from "../models";
// @ts-ignore
import { InvoiceModelODataResultCollection } from "../models";
/**
 * InvoiceApi - axios parameter creator
 * @export
 */
export const InvoiceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiInvoiceDRAFTDocEntryGet", "docEntry", docEntry);
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiInvoiceDRAFTDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Invoice/{DRAFT}/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTGet: async (
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiInvoiceDRAFTGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Invoice/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTGetFormIdDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiInvoiceDRAFTGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiInvoiceDRAFTGetFormIdDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Invoice/{DRAFT}/GetFormId/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTPatch: async (
      dRAFT: string,
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiInvoiceDRAFTPatch", "dRAFT", dRAFT);
      const localVarPath = `/api/Invoice/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiInvoiceDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTUpdatePost: async (
      dRAFT: string,
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiInvoiceDRAFTUpdatePost", "dRAFT", dRAFT);
      const localVarPath = `/api/Invoice/{DRAFT}/Update`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiInvoiceDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiInvoiceDocEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Invoice/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGet: async (
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invoice`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to provide valid dimensions of Invoice GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGetDocumentFilterDimensionsGet: async (
      $filter?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invoice/GetDocumentFilterDimensions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGetFileUriListDocEntryGet: async (
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiInvoiceGetFileUriListDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/Invoice/GetFileUriList/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGetFormIdDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiInvoiceGetFormIdDocEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Invoice/GetFormId/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoicePatch: async (
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invoice`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiInvoiceDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceSearchContractDetailsGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invoice/SearchContractDetails`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceSearchGridViewGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invoice/SearchGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceSearchNFilterGridViewPost: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invoice/SearchNFilterGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliverySearchNFilterGridViewPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceUpdatePost: async (
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invoice/Update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiInvoiceDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("docEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Invoice({DocEntry})`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InvoiceApi - functional programming interface
 * @export
 */
export const InvoiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InvoiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceDRAFTDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceDRAFTDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceDRAFTGet(
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InvoiceModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceDRAFTGet(
          dRAFT,
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceDRAFTGetFormIdDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceDRAFTGetFormIdDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceDRAFTPatch(
      dRAFT: string,
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceDRAFTPatch(
          dRAFT,
          apiInvoiceDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceDRAFTUpdatePost(
      dRAFT: string,
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceDRAFTUpdatePost(
          dRAFT,
          apiInvoiceDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceDocEntryGet(
          docEntry,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceGet(
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InvoiceModelODataResultCollection>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceGet(
        isDraft,
        $top,
        $skip,
        $filter,
        $orderby,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used to provide valid dimensions of Invoice GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceGetDocumentFilterDimensionsGet(
      $filter?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DocumentFilterDimensions>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceGetDocumentFilterDimensionsGet(
          $filter,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceGetFileUriListDocEntryGet(
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FileUriODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceGetFileUriListDocEntryGet(
          docEntry,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceGetFormIdDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceGetFormIdDocEntryGet(
          docEntry,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoicePatch(
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoicePatch(
        apiInvoiceDRAFTPatchRequest,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceSearchContractDetailsGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InvoiceModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceSearchContractDetailsGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceSearchGridViewGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InvoiceModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceSearchGridViewGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceSearchNFilterGridViewPost(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InvoiceModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceSearchNFilterGridViewPost(
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          apiDeliverySearchNFilterGridViewPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiInvoiceDRAFTPatchRequest} [apiInvoiceDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvoiceUpdatePost(
      apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvoiceUpdatePost(
          apiInvoiceDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async docEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.docEntryGet(
        docEntry,
        isDraft,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * InvoiceApi - factory interface
 * @export
 */
export const InvoiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InvoiceApiFp(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {InvoiceApiApiInvoiceDRAFTDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTDocEntryGet(
      requestParameters: InvoiceApiApiInvoiceDRAFTDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModel> {
      return localVarFp
        .apiInvoiceDRAFTDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {InvoiceApiApiInvoiceDRAFTGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTGet(
      requestParameters: InvoiceApiApiInvoiceDRAFTGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModelODataResultCollection> {
      return localVarFp
        .apiInvoiceDRAFTGet(
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTGetFormIdDocEntryGet(
      requestParameters: InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiInvoiceDRAFTGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {InvoiceApiApiInvoiceDRAFTPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTPatch(
      requestParameters: InvoiceApiApiInvoiceDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModel> {
      return localVarFp
        .apiInvoiceDRAFTPatch(
          requestParameters.dRAFT,
          requestParameters.apiInvoiceDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {InvoiceApiApiInvoiceDRAFTUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDRAFTUpdatePost(
      requestParameters: InvoiceApiApiInvoiceDRAFTUpdatePostRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModel> {
      return localVarFp
        .apiInvoiceDRAFTUpdatePost(
          requestParameters.dRAFT,
          requestParameters.apiInvoiceDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {InvoiceApiApiInvoiceDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceDocEntryGet(
      requestParameters: InvoiceApiApiInvoiceDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModel> {
      return localVarFp
        .apiInvoiceDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {InvoiceApiApiInvoiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGet(
      requestParameters: InvoiceApiApiInvoiceGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModelODataResultCollection> {
      return localVarFp
        .apiInvoiceGet(
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used to provide valid dimensions of Invoice GridView
     * @param {InvoiceApiApiInvoiceGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGetDocumentFilterDimensionsGet(
      requestParameters: InvoiceApiApiInvoiceGetDocumentFilterDimensionsGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DocumentFilterDimensions> {
      return localVarFp
        .apiInvoiceGetDocumentFilterDimensionsGet(
          requestParameters.$filter,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {InvoiceApiApiInvoiceGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGetFileUriListDocEntryGet(
      requestParameters: InvoiceApiApiInvoiceGetFileUriListDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FileUriODataResultCollection> {
      return localVarFp
        .apiInvoiceGetFileUriListDocEntryGet(
          requestParameters.docEntry,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {InvoiceApiApiInvoiceGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceGetFormIdDocEntryGet(
      requestParameters: InvoiceApiApiInvoiceGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiInvoiceGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {InvoiceApiApiInvoicePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoicePatch(
      requestParameters: InvoiceApiApiInvoicePatchRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModel> {
      return localVarFp
        .apiInvoicePatch(requestParameters.apiInvoiceDRAFTPatchRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {InvoiceApiApiInvoiceSearchContractDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceSearchContractDetailsGet(
      requestParameters: InvoiceApiApiInvoiceSearchContractDetailsGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModelODataResultCollection> {
      return localVarFp
        .apiInvoiceSearchContractDetailsGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {InvoiceApiApiInvoiceSearchGridViewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceSearchGridViewGet(
      requestParameters: InvoiceApiApiInvoiceSearchGridViewGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModelODataResultCollection> {
      return localVarFp
        .apiInvoiceSearchGridViewGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {InvoiceApiApiInvoiceSearchNFilterGridViewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceSearchNFilterGridViewPost(
      requestParameters: InvoiceApiApiInvoiceSearchNFilterGridViewPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModelODataResultCollection> {
      return localVarFp
        .apiInvoiceSearchNFilterGridViewPost(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {InvoiceApiApiInvoiceUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvoiceUpdatePost(
      requestParameters: InvoiceApiApiInvoiceUpdatePostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModel> {
      return localVarFp
        .apiInvoiceUpdatePost(
          requestParameters.apiInvoiceDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {InvoiceApiDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet(
      requestParameters: InvoiceApiDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<InvoiceModel> {
      return localVarFp
        .docEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiInvoiceDRAFTDocEntryGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceDRAFTDocEntryGetRequest
 */
export interface InvoiceApiApiInvoiceDRAFTDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof InvoiceApiApiInvoiceDRAFTDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof InvoiceApiApiInvoiceDRAFTDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiInvoiceDRAFTGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceDRAFTGetRequest
 */
export interface InvoiceApiApiInvoiceDRAFTGetRequest {
  /**
   *
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof InvoiceApiApiInvoiceDRAFTGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiInvoiceDRAFTGetFormIdDocEntryGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGetRequest
 */
export interface InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiInvoiceDRAFTPatch operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceDRAFTPatchRequest
 */
export interface InvoiceApiApiInvoiceDRAFTPatchRequest {
  /**
   *
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTPatch
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiInvoiceDRAFTPatchRequest}
   * @memberof InvoiceApiApiInvoiceDRAFTPatch
   */
  readonly apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest;
}

/**
 * Request parameters for apiInvoiceDRAFTUpdatePost operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceDRAFTUpdatePostRequest
 */
export interface InvoiceApiApiInvoiceDRAFTUpdatePostRequest {
  /**
   *
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDRAFTUpdatePost
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiInvoiceDRAFTPatchRequest}
   * @memberof InvoiceApiApiInvoiceDRAFTUpdatePost
   */
  readonly apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest;
}

/**
 * Request parameters for apiInvoiceDocEntryGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceDocEntryGetRequest
 */
export interface InvoiceApiApiInvoiceDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof InvoiceApiApiInvoiceDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof InvoiceApiApiInvoiceDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiInvoiceGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceGetRequest
 */
export interface InvoiceApiApiInvoiceGetRequest {
  /**
   *
   * @type {boolean}
   * @memberof InvoiceApiApiInvoiceGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiInvoiceGetDocumentFilterDimensionsGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceGetDocumentFilterDimensionsGetRequest
 */
export interface InvoiceApiApiInvoiceGetDocumentFilterDimensionsGetRequest {
  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGetDocumentFilterDimensionsGet
   */
  readonly $filter?: string;
}

/**
 * Request parameters for apiInvoiceGetFileUriListDocEntryGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceGetFileUriListDocEntryGetRequest
 */
export interface InvoiceApiApiInvoiceGetFileUriListDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof InvoiceApiApiInvoiceGetFileUriListDocEntryGet
   */
  readonly docEntry: number;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGetFileUriListDocEntryGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGetFileUriListDocEntryGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGetFileUriListDocEntryGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceGetFileUriListDocEntryGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiInvoiceGetFormIdDocEntryGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceGetFormIdDocEntryGetRequest
 */
export interface InvoiceApiApiInvoiceGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof InvoiceApiApiInvoiceGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof InvoiceApiApiInvoiceGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiInvoicePatch operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoicePatchRequest
 */
export interface InvoiceApiApiInvoicePatchRequest {
  /**
   *
   * @type {ApiInvoiceDRAFTPatchRequest}
   * @memberof InvoiceApiApiInvoicePatch
   */
  readonly apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest;
}

/**
 * Request parameters for apiInvoiceSearchContractDetailsGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceSearchContractDetailsGetRequest
 */
export interface InvoiceApiApiInvoiceSearchContractDetailsGetRequest {
  /**
   *
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchContractDetailsGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchContractDetailsGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchContractDetailsGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchContractDetailsGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchContractDetailsGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchContractDetailsGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiInvoiceSearchGridViewGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceSearchGridViewGetRequest
 */
export interface InvoiceApiApiInvoiceSearchGridViewGetRequest {
  /**
   *
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchGridViewGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchGridViewGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchGridViewGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchGridViewGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchGridViewGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchGridViewGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiInvoiceSearchNFilterGridViewPost operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceSearchNFilterGridViewPostRequest
 */
export interface InvoiceApiApiInvoiceSearchNFilterGridViewPostRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchNFilterGridViewPost
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchNFilterGridViewPost
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchNFilterGridViewPost
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchNFilterGridViewPost
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiApiInvoiceSearchNFilterGridViewPost
   */
  readonly $expand?: string;

  /**
   * The filter and search string requirement.
   * @type {ApiDeliverySearchNFilterGridViewPostRequest}
   * @memberof InvoiceApiApiInvoiceSearchNFilterGridViewPost
   */
  readonly apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest;
}

/**
 * Request parameters for apiInvoiceUpdatePost operation in InvoiceApi.
 * @export
 * @interface InvoiceApiApiInvoiceUpdatePostRequest
 */
export interface InvoiceApiApiInvoiceUpdatePostRequest {
  /**
   *
   * @type {ApiInvoiceDRAFTPatchRequest}
   * @memberof InvoiceApiApiInvoiceUpdatePost
   */
  readonly apiInvoiceDRAFTPatchRequest?: ApiInvoiceDRAFTPatchRequest;
}

/**
 * Request parameters for docEntryGet operation in InvoiceApi.
 * @export
 * @interface InvoiceApiDocEntryGetRequest
 */
export interface InvoiceApiDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof InvoiceApiDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof InvoiceApiDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof InvoiceApiDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * InvoiceApi - object-oriented interface
 * @export
 * @class InvoiceApi
 * @extends {BaseAPI}
 */
export class InvoiceApi extends BaseAPI {
  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {InvoiceApiApiInvoiceDRAFTDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceDRAFTDocEntryGet(
    requestParameters: InvoiceApiApiInvoiceDRAFTDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceDRAFTDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {InvoiceApiApiInvoiceDRAFTGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceDRAFTGet(
    requestParameters: InvoiceApiApiInvoiceDRAFTGetRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceDRAFTGet(
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceDRAFTGetFormIdDocEntryGet(
    requestParameters: InvoiceApiApiInvoiceDRAFTGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceDRAFTGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {InvoiceApiApiInvoiceDRAFTPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceDRAFTPatch(
    requestParameters: InvoiceApiApiInvoiceDRAFTPatchRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceDRAFTPatch(
        requestParameters.dRAFT,
        requestParameters.apiInvoiceDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {InvoiceApiApiInvoiceDRAFTUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceDRAFTUpdatePost(
    requestParameters: InvoiceApiApiInvoiceDRAFTUpdatePostRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceDRAFTUpdatePost(
        requestParameters.dRAFT,
        requestParameters.apiInvoiceDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {InvoiceApiApiInvoiceDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceDocEntryGet(
    requestParameters: InvoiceApiApiInvoiceDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {InvoiceApiApiInvoiceGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceGet(
    requestParameters: InvoiceApiApiInvoiceGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceGet(
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used to provide valid dimensions of Invoice GridView
   * @param {InvoiceApiApiInvoiceGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceGetDocumentFilterDimensionsGet(
    requestParameters: InvoiceApiApiInvoiceGetDocumentFilterDimensionsGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceGetDocumentFilterDimensionsGet(
        requestParameters.$filter,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {InvoiceApiApiInvoiceGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceGetFileUriListDocEntryGet(
    requestParameters: InvoiceApiApiInvoiceGetFileUriListDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceGetFileUriListDocEntryGet(
        requestParameters.docEntry,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {InvoiceApiApiInvoiceGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceGetFormIdDocEntryGet(
    requestParameters: InvoiceApiApiInvoiceGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {InvoiceApiApiInvoicePatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoicePatch(
    requestParameters: InvoiceApiApiInvoicePatchRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoicePatch(requestParameters.apiInvoiceDRAFTPatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {InvoiceApiApiInvoiceSearchContractDetailsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceSearchContractDetailsGet(
    requestParameters: InvoiceApiApiInvoiceSearchContractDetailsGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceSearchContractDetailsGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {InvoiceApiApiInvoiceSearchGridViewGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceSearchGridViewGet(
    requestParameters: InvoiceApiApiInvoiceSearchGridViewGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceSearchGridViewGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Searches the grid view.
   * @param {InvoiceApiApiInvoiceSearchNFilterGridViewPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceSearchNFilterGridViewPost(
    requestParameters: InvoiceApiApiInvoiceSearchNFilterGridViewPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceSearchNFilterGridViewPost(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {InvoiceApiApiInvoiceUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public apiInvoiceUpdatePost(
    requestParameters: InvoiceApiApiInvoiceUpdatePostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .apiInvoiceUpdatePost(
        requestParameters.apiInvoiceDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {InvoiceApiDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  public docEntryGet(
    requestParameters: InvoiceApiDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return InvoiceApiFp(this.configuration)
      .docEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
